import { Box, makeStyles, Menu, Theme } from "@material-ui/core";
import clsx from "clsx";
import * as React from "react";

const useStyles = makeStyles((theme: Theme) => ({
  dropdown: {
    "& > .MuiMenu-paper": {
      border: "1px solid #3F51B5",
      boxShadow: "0px 2px 24px rgba(0, 0, 0, 0.2)",
      // this is necessary to cover the border from the button.
      transform: "translateY(-1px) !important",

      "& > ul": {
        padding: 0,
      },
    },
  },
  actionLabelBox: {
    height: 40,
    position: "sticky",
    top: 0,
    background: "white",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingLeft: theme.spacing(2),
    borderBottom: "1px solid #D9D9D9",
    color: "#444444",
    fontSize: "1rem",
  },
}));

interface DropdownProps {
  anchorEl?: HTMLElement | null;
  handleClose: () => void;
  id: string;
  show: boolean;
  actionLabel?: React.ReactNode;
}

export default function DropdownBox({
  anchorEl,
  id,
  handleClose,
  children,
  show,
  actionLabel,
}: React.PropsWithChildren<DropdownProps>) {
  const classes = useStyles();

  if (!show) {
    return null;
  }

  return (
    <Menu
      id={id}
      anchorEl={anchorEl}
      keepMounted
      open={show}
      onClose={handleClose}
      onClick={(e) => e.stopPropagation()}
      className={clsx(classes.dropdown)}
      PaperProps={{
        style: { maxHeight: 300, minWidth: 200 },
      }}
      anchorOrigin={{
        horizontal: "left",
        vertical: "bottom",
      }}
      anchorPosition={{ top: 200, left: 0 }}
      anchorReference={"anchorEl"}
      getContentAnchorEl={null}
    >
      {actionLabel && (
        <Box className={clsx(classes.actionLabelBox)}>{actionLabel}</Box>
      )}
      {children}
    </Menu>
  );
}
